import { HTTP } from './helpers/http.js'

const oauth = {
  getConsentInfo(sessionId) {
    return HTTP.get('/api/v1/oauth/consent-info', {
      params: { session: sessionId },
    })
  },

  submitConsent(sessionId, accessToken, decision) {
    return HTTP.post('/api/v1/oauth/consent', {
      sessionId,
      accessToken,
      decision,
    })
  },
}

export default oauth
